function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.2,
  cx: 50,
  cy: 50,
  r: 50,
  fill: "#15A9E1"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 51.9998,
  y: 29,
  width: 3,
  height: 42,
  fill: "#005D81"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 58,
  y: 35,
  width: 3,
  height: 30,
  fill: "#005D81"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 64.0002,
  y: 44,
  width: 3,
  height: 15,
  fill: "#005D81"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 69.9995,
  y: 40.9999,
  width: 3,
  height: 21,
  fill: "#005D81"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 75.9999,
  y: 47.0001,
  width: 3,
  height: 9.3,
  fill: "#005D81"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 82.0001,
  y: 50,
  width: 3,
  height: 3,
  fill: "#005D81"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 46.0001,
  y: 35,
  width: 3,
  height: 30,
  fill: "#005D81"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 40.0001,
  y: 40.9999,
  width: 3,
  height: 21,
  fill: "#005D81"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 33.9999,
  y: 47.0001,
  width: 3,
  height: 9.3,
  fill: "#005D81"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 27.9999,
  y: 44,
  width: 3,
  height: 15,
  fill: "#005D81"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 22.0002,
  y: 47.0001,
  width: 3,
  height: 9.3,
  fill: "#005D81"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 50,
  width: 3,
  height: 3,
  fill: "#005D81"
});

var SvgAudio = function SvgAudio(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAudio, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/audio.f3d0f0a3.svg";
export { ForwardRef as ReactComponent };